import React , {useEffect, useRef,useState} from 'react';
import { Checkbox,Flex, } from '@mantine/core';
import Dygraph from 'dygraphs';
import './App.css';
import "dygraphs/src/extras/crosshair.js";
//import "dygraphs/src/extras/smooth-plotter.js";

const style = {
  graphBlock: {
    borderTopColor: '#22242626',
    borderTopStyle: 'solid',
    borderTopWidth: 1,
    marginBottom: 16,
    paddingBottom: 24,
    paddingLeft: 16,
  },
  legend: {
    fontSize: '0.8em',
    paddingLeft: 56,
    paddingTop: 5,
    textAlign: 'left',
  },
};

const colors = ['indigo','teal','orange','cyan','gray','pink','lime','grape','yellow','green','violet','dark','red'];

const Dygraphs = (props) => {
  const dygraphsDiv = useRef(null);
  var dygraph = null ;
  var labels = props.labels.slice(1);
  const setVisible = props.setVisible;

  var Options = {
    axes: {
      x: {
        axisLabelFormatter: formatValue,
        axisLabelFontSize: 8,
      }
    },
    colors: colors,
    width: props.width,
    height: props.height,
    highlightSeriesOpts: { strokeWidth: 2 },
    includeZero: true,
    labels: props.labels,
 //   labelsDiv: props.legendDiv,
    legend: 'follow',
    legendFormatter: legendFormatter,
    connectSeparatedPoints: true,
    drawGapEdgePoints: true,
    showRangeSelector: true,
 //   ylabel: 'Value',
    resizable: "both",
    rollPeriod: parseInt(props.rollPeriod),
 //   showRoller: true,
    visibility: props.visible ,
 //   fillGraph: true,
    interactionModel: Dygraph.defaultInteractionModel,
 //   plugins: [
 //     new Dygraph.Plugins.Crosshair({
 //       direction: "vertical"
 //     })
 //   ],
  }

  var handle = props.handle;
  var setHandle = props.setHandle;
  useEffect(() => {
    if (!dygraph && !handle) {
      createGraph();
    } else if (handle) {
      reloadDygraph(handle);
    } else if (dygraph) {
      reloadDygraph(dygraph);
    } 
  },[props]);

  var g = handle ? handle : dygraph ;

  window.onbeforeunload = function () {
    destroyDygraph();
    return null; 
  }
 
  useEffect(() => {
    return () => {
      destroyDygraph();
    }
  },[]);

  function destroyDygraph() {
    if (handle && handle.file_ && handle.canvas_) {
      handle.destroy();
    }
    if (dygraph && dygraph.file_ && dygraph.canvas_) {
      dygraph.destroy();
    }
    return null;
  }

  function createGraph() {
    dygraph = new Dygraph(dygraphsDiv.current,props.data,Options);
    setHandle(dygraph);
    return null;
  }

  function reloadDygraph(hdl) {
    if (props.data !== hdl.file_ ) {
      destroyDygraph();
      createGraph();
    } else {
      hdl.updateOptions({
        rollPeriod: parseInt(props.rollPeriod),
        visibility: props.visible
      });
    }
    return null;
  }

  function formatValue(timestamp) {
    return props.formatTimestamp(timestamp);
  }

  function legendFormatter(data) {
    if (data.x === undefined) {
      const defaultLegend = data.series.map((series) => `${series.dashHTML} ${series.labelHTML}`).join(' ');
     return `<br/> ${defaultLegend}`;
    }

    let html = ` ${formatValue(data.xHTML)}<br/>`;
    data.series.map(series => {
      if (!series.isVisible) return null;

      let labeledData = `${series.labelHTML}: ${series.yHTML} `;
      if (series.isHighlighted) {
        labeledData = `<b>${labeledData}</b>`;
      }

  //    html += ` ${series.dashHTML} ${labeledData}` + "&ensp;";
      html += "&nbsp;" + `${series.dashHTML} ${labeledData}<br/>`;
      return null;
    });

    return html;  
  }

  function change(e) {
    if (dygraph) {
      dygraph.setVisibility(parseInt(e.target.id), e.target.checked);
    } else if (handle) {
      handle.setVisibility(parseInt(e.target.id), e.target.checked);
    }
    const _ = require("lodash");
    const visibleCopied = _.cloneDeep(props.visible); 
    visibleCopied[parseInt(e.target.id)] = e.target.checked;
    setVisible(visibleCopied);
    return null;
  }  
  
  return (
    <Flex mt={10} gap={4} direction={"column"} style={style.graphBlock} key={props.index}>
      <Flex>
        <div ref={dygraphsDiv}  />
      </Flex>
      <Flex mt={15} style={{ display: "flex", gap: 16 }}>
        { labels.map((v,idx) => (
          <Checkbox size="xs" id={idx.toString()} label={v} color={colors[idx]} defaultChecked onChange={e=>change(e)}/>
        ))}     
      </Flex>
    </Flex>
  );

}

export default Dygraphs;
